<template>
    <div class="page-main">
        <div class="spaceBetween">
            <page-title />
            <div class="spaceRight op-btn">
                <el-button @click="goBack">
                    <i class="el-icon-arrow-left"></i>
                    <span>Back</span>
                </el-button>
            </div>
        </div>

        <page-card title="Add Plan">

            <div slot="body">
                <div class="airdrop-status" style="display: flex;align-items: center;" v-loading="statsLoading">
                    <div style="width: 180px;">Airdrop UNIT release status</div>
                    <div style="width: 100%;">
                        <div>Total: {{ totalAmount }} UNIT</div>
                        <div class="progress-container">
                            <div class="progress-bar" :style="{ width: progressPercent + '%' }"></div>
                        </div>
                        <div class="airdrop-numbers">
                            <span>Releasable: {{ releasableAmount }} UNIT</span>
                            <span>Released: {{ releasedAmount }} UNIT</span>
                        </div>
                    </div>

                </div>

                <div class="form-container">
                    <div class="form-item">
                        <div class="form-label">Plan name:</div>
                        <el-input style="width: 45%;" v-model="planForm.planName"
                            placeholder="Enter plan name"></el-input>
                        <div class="error-message" v-if="planNameError">{{ planNameError }}</div>
                    </div>

                    <div class="form-item" style="flex-direction: column;">
                        <div style="display: flex;align-items: baseline;width: 100%;">
                            <div class="form-label">Planned release:</div>
                            <el-input v-model.trim="planForm.planAmount" placeholder="Enter planned release amount"
                                @input="handlePlanAmountInput" @blur="formatPlanAmount" maxlength="20"
                                style="width: 27%;" @change="onPlanAmountChange"></el-input>
                            <span class="unit-label">UNIT</span>
                            <div class="error-message" v-if="planAmountError">{{ planAmountError }}</div>

                            <div style="display: flex;flex-direction: column;align-items: end;">
                                <div style="display: flex;align-items: center;">
                                    <div class="form-label release-percentage-label">Release percentage:</div>

                                    <el-input style="width: 100%;" v-model.trim="planForm.releasePercentage"
                                        placeholder="Enter release percentage" @input="handleReleasePercentageInput"
                                        @blur="formatReleasePercentage" @change="onReleasePercentageChange"
                                        maxlength="30">
                                        <template slot="append">%</template>
                                    </el-input>

                                </div>
                                <div class="percentage-tips">Percentage of total supply in the contract({{ totalAmount
                                    }}).
                                </div>
                            </div>

                            <div class="error-message" v-if="releasePercentageError">{{ releasePercentageError }}</div>

                        </div>

                    </div>

                    <!-- <div class="form-item">
                        <div class="form-label"></div>
                        <div class="percentage-tips">Percentage of total supply in the contract({{ totalAmount }}).
                        </div>
                    </div> -->

                    <div class="form-item">
                        <div class="form-label">Claim Method:</div>
                        <div class="radio-group">
                            <el-radio v-model="planForm.claimMethod" :label="0">Direct</el-radio>
                            <el-radio v-model="planForm.claimMethod" :label="1">Self claim</el-radio>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">Unlock frequency:</div>
                        <div class="radio-group">
                            <el-radio v-model="planForm.unlockFrequency" :label="0">Single</el-radio>
                            <el-radio v-model="planForm.unlockFrequency" :label="1">Liner</el-radio>
                        </div>
                    </div>

                    <!-- 线性解锁时显示的额外选项 -->
                    <div class="form-item" v-if="planForm.unlockFrequency === 1">
                        <div class="form-label">Distribution Frequency:</div>
                        <div class="input-with-select">
                            <el-input v-model="planForm.distributionFrequency" style="width: 250px;"
                                placeholder="Enter distribution frequency" @input="handleDistributionFrequencyInput"
                                @blur="formatDistributionFrequency" @change="validateDistributionFrequency">
                            </el-input>
                            <el-select v-model="distributionFrequencyUnit" placeholder="Select" style="width: 100px;">
                                <el-option label="Day" value="Day"></el-option>
                            </el-select>
                        </div>
                        <div class="error-message" v-if="distributionFrequencyError">{{ distributionFrequencyError }}
                        </div>
                    </div>

                    <div class="form-item" v-if="planForm.unlockFrequency === 1">
                        <div class="form-label">Unlock Period:</div>
                        <div class="input-with-select">
                            <el-input v-model="planForm.unlockPeriod" style="width: 250px;"
                                placeholder="Enter unlock period" @input="handleUnlockPeriodInput"
                                @blur="formatUnlockPeriod" @change="validateUnlockPeriod">
                            </el-input>
                            <el-select v-model="unlockPeriodUnit" placeholder="Select" style="width: 100px;">
                                <el-option label="Day" value="Day"></el-option>
                            </el-select>
                        </div>
                        <div class="error-message" v-if="unlockPeriodError">{{ unlockPeriodError }}</div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">Unlock date(UTC time):</div>
                        <el-date-picker style="width: 37%;" v-model="planForm.unlockDate" type="datetime"
                            placeholder="Select date and time" format="yyyy-MM-dd HH:mm" value-format="timestamp"
                            :picker-options="{ disabledDate: disablePastDates, defaultTime: '00:00:00' }"
                            :default-time="'00:00:00'" @change="handleDateChange">
                        </el-date-picker>
                        <div class="utc-time-note" v-if="planForm.unlockDate">UTC: {{ formattedUtcTime }}</div>
                        <div class="error-message" v-if="unlockDateError">{{ unlockDateError }}</div>
                    </div>

                    <div class="whitelist-section">
                        <div class="whitelist-header">
                            <div class="form-label">Add whitelist:</div>
                            <div class="whitelist-error" v-if="whitelistError">
                                {{ whitelistError }}
                            </div>
                        </div>

                        <div class="whitelist-table">
                            <div class="whitelist-table-header">
                                <div class="index-column">
                                    <el-checkbox v-model="selectAllComputed"
                                        @change="handleSelectAllChange"></el-checkbox>
                                    <span class="index-title">No.</span>
                                </div>
                                <div class="address-column">Address</div>
                                <div class="amount-column">Amount of Tokens</div>
                                <div v-if="planForm.unlockFrequency === 1" class="extra-info-column">Start date</div>
                                <div v-if="planForm.unlockFrequency === 1" class="extra-info-column">Fully unlocked date
                                </div>
                                <div v-if="planForm.unlockFrequency === 1" class="extra-info-column">Unlock times</div>
                                <div v-if="planForm.unlockFrequency === 1" class="extra-info-column">Amount per unlock
                                </div>
                                <div class="action-column">
                                    <div class="info-icon" v-if="whitelist.length > 0">
                                        <el-tooltip
                                            content="The total amount in whitelist must match the planned release amount"
                                            placement="top">
                                            <i class="el-icon-warning-outline"></i>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="whitelist-table-body">
                                <div v-for="(item, index) in whitelist" :key="index" class="whitelist-item">
                                    <div class="index-column">
                                        <el-checkbox v-model="item.selected"
                                            @change="handleItemSelectChange"></el-checkbox>
                                        <span class="index-number">{{ index + 1 }}</span>
                                    </div>
                                    <div class="address-column">
                                        <el-input v-model="item.address" placeholder="Enter address"
                                            @blur="validateAddress(index)"></el-input>
                                        <div class="error-message" v-if="item.addressError">{{ item.addressError }}
                                        </div>
                                    </div>
                                    <div class="amount-column">
                                        <el-input v-model.trim="item.amount" placeholder="Enter amount"
                                            @input="(value) => handleWhitelistAmountInput(value, index)"
                                            @blur="() => formatWhitelistAmount(index)" maxlength="20"></el-input>
                                    </div>
                                    <div v-if="planForm.unlockFrequency === 1" class="extra-info-column info-text">
                                        {{ getStartDate() }}
                                    </div>
                                    <div v-if="planForm.unlockFrequency === 1" class="extra-info-column info-text">
                                        {{ getFullyUnlockedDate(item) }}
                                    </div>
                                    <div v-if="planForm.unlockFrequency === 1" class="extra-info-column info-text">
                                        {{ getUnlockTimes(item) }}
                                    </div>
                                    <div v-if="planForm.unlockFrequency === 1" class="extra-info-column info-text">
                                        {{ getAmountPerUnlock(item) }}
                                    </div>
                                    <div class="action-column">
                                        <el-button type="danger" @click="deleteWhitelistItem(index)">Delete</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="whitelist-actions">
                            <el-button @click="addWhitelistItem">Add</el-button>
                            <el-button @click="importWhitelist">Import whitelist</el-button>
                            <el-button type="danger" :disabled="!hasSelectedItems"
                                @click="batchDeleteWhitelistItems">Batch
                                Delete</el-button>
                            <el-button type="primary" @click="distributeAmountEvenly">Distribute Amount
                                Evenly</el-button>
                            <input type="file" ref="fileInput" style="display: none" accept=".csv,.xlsx"
                                @change="handleFileUpload" />
                        </div>
                    </div>

                    <div class="form-actions">
                        <el-button @click="goBack">Cancel</el-button>
                        <el-button type="primary" @click="showConfirmation" :loading="submitting">Submit</el-button>
                    </div>
                </div>
            </div>
        </page-card>

        <!-- 地址确认弹窗 -->
        <el-dialog title="Address Confirmation" :visible.sync="addressConfirmVisible" width="40%"
            :close-on-click-modal="false" center>
            <div class="address-confirmation">
                <p class="confirm-text">Please confirm that these recipients' addresses are valid and usable.</p>

                <div class="confirm-actions">
                    <el-button @click="addressConfirmVisible = false">I'll check again</el-button>
                    <el-button type="primary" @click="confirmAddresses" :loading="confirmLoading">I have
                        confirmed</el-button>
                </div>

                <div class="confirm-tip" v-if="confirmSuccess">
                    <i class="el-icon-success"></i>
                    <!-- <span>【confirmed】, 进入下一步</span> -->
                </div>
            </div>
        </el-dialog>

        <!-- 导入白名单弹窗 -->
        <el-dialog title="Import whitelist" :visible.sync="importWhitelistVisible" width="600px"
            :close-on-click-modal="false" center>
            <div class="import-whitelist-dialog">
                <p class="import-description">
                    Uploading a CSV list will replace any existing entries you've already added to the form.
                </p>

                <div class="file-upload-section">
                    <el-button type="primary" @click="triggerFileInput" class="choose-file-btn">
                        Choose file
                    </el-button>
                    <span v-if="selectedFileName" class="selected-file-name">
                        {{ selectedFileName }}
                        <i class="el-icon-close" @click="clearSelectedFile"></i>
                    </span>
                </div>

                <div class="format-instructions">
                    <p class="instructions-text">
                        You can compile a CSV list of recipients and distribution details
                        (maximum of 60) offline and use it to quickly populate your recipient list.
                    </p>

                    <p class="csv-format-title">Your CSV should contain data in the following order</p>
                    <p class="csv-format-example">Recipient address, Amount of tokens, Unlock start date</p>

                    <div class="date-format-note">
                        <p>The Unlock start date must be provided in one of the following formats</p>
                        <p>YYYY-MM-DD (e.g. 2025-12-31)</p>
                    </div>
                </div>

                <div class="dialog-actions">
                    <el-button @click="importWhitelistVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="handleImportConfirm" :disabled="!selectedFileName">
                        Import
                    </el-button>
                </div>

                <input type="file" ref="importFileInput" style="display: none" accept=".csv"
                    @change="handleImportFileSelect" />
            </div>
        </el-dialog>

        <ErrorMsg ref="ErrorMsg"></ErrorMsg>
    </div>
</template>

<script>
import { setPlan, includeCsv } from '@/api/tokenlocker'
import * as XLSX from 'xlsx'
import Web3 from 'web3'
import ErrorMsg from '@/components/ErrorMsg'
import { getAbi } from '@/api/file'

export default {
    components: {
        ErrorMsg
    },
    data() {
        return {
            addressConfirmVisible: false,
            confirmSuccess: false,
            confirmLoading: false,
            totalAmount: '',
            releasableAmount: '',
            releasedAmount: '',
            progressPercent: 0, // Percentage value
            submitting: false,
            statsLoading: false,
            distributionFrequencyUnit: 'Day',
            unlockPeriodUnit: 'Day',
            // 防抖定时器
            confirmTimer: null,

            planForm: {
                planName: '',
                planAmount: '',
                releasePercentage: '',
                claimMethod: 0,
                unlockFrequency: 0,
                distributionFrequency: 0,
                unlockPeriod: 0,
                unlockDate: this.getDefaultUnlockDate(),
            },

            whitelist: [
                { address: '', amount: '', selected: false }
            ],

            planNameError: '',
            whitelistError: '',
            planAmountError: '',
            releasePercentageError: '',
            unlockDateError: '',
            whitelistTotal: 0,
            contractAddress: '',
            TokenLockerAbi: [],
            distributionFrequencyError: '',
            unlockPeriodError: '',
            formattedUtcTime: '',
            selectAll: false,
            importWhitelistVisible: false,
            selectedFileName: '',
        }
    },
    async mounted() {
        await this.getContractInfo();
        this.getStats();
        // 初始化UTC时间显示
        this.handleDateChange(this.planForm.unlockDate);
    },
    watch: {
        'planForm.unlockFrequency': {
            handler(newVal) {
                console.log('unlockFrequency changed:', newVal);
                if (newVal === 1) {
                    this.planForm.distributionFrequency = 30;
                    this.planForm.unlockPeriod = 365;
                } else {
                    this.planForm.distributionFrequency = 0;
                    this.planForm.unlockPeriod = 0;
                }
            },
            immediate: true
        }
    },
    computed: {
        isWhitelistValid() {
            if (this.whitelist.length === 0) return false;

            // Check if each whitelist entry has an address and amount
            for (const item of this.whitelist) {
                if (!item.address || !item.amount) return false;
            }

            // Check if the whitelist total matches the planned release amount
            return this.whitelistTotal === parseFloat(this.planForm.planAmount || 0);
        },
        hasSelectedItems() {
            return this.whitelist.some(item => item.selected);
        },
        // 计算全选状态：当所有项都被选中且不为空时为true
        isAllSelected() {
            return this.whitelist.length > 0 && this.whitelist.every(item => item.selected);
        },
        // 双向绑定的全选计算属性
        selectAllComputed: {
            get() {
                return this.isAllSelected;
            },
            set(value) {
                this.selectAll = value;
            }
        }
    },
    methods: {
        // 获取默认解锁日期（当前日期的后两天，保持当前时分秒）
        getDefaultUnlockDate() {
            const dayAfterTomorrow = new Date();
            dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
            // 保持当前的时分秒，不修改
            return dayAfterTomorrow.getTime();
        },

        async getContractInfo() {
            const res = await getAbi('TokenLocker')
            if (res.code === 0 && res.data) {
                this.contractAddress = res.data.address
                this.TokenLockerAbi = res.data.abi
            }
        },
        // Helper function to format numbers
        formatNumber(num) {
            return Number(num).toLocaleString();
        },
        async getStats() {
            try {
                this.statsLoading = true;

                // Initialize Web3, preferring MetaMask if available, otherwise use public node
                let web3;
                if (window.ethereum) {
                    web3 = new Web3(window.ethereum);
                    // Check if MetaMask is connected
                    try {
                        // Silently check accounts without showing MetaMask
                        const accounts = await web3.eth.getAccounts();
                        if (accounts.length === 0) {
                            console.log('MetaMask not connected, using public node');
                            web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                        }
                    } catch (error) {
                        console.log('Failed to check wallet connection, using public node', error);
                        web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                    }
                } else {
                    // No MetaMask, use public node
                    console.log('MetaMask not detected, using public node');
                    web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                }

                // Create contract instance
                const contract = new web3.eth.Contract(this.TokenLockerAbi, this.contractAddress);

                // Call contract functions to get total locked amount and available amount
                const [totalLockedAmount, availableAmount] = await Promise.all([
                    contract.methods.getTotalLockedAmount().call(),
                    contract.methods.getTotalAvailableAmount().call()
                ]);
                console.log('totalLockedAmount', totalLockedAmount);
                console.log('availableAmount', availableAmount);
                // Convert Wei to UNIT and format numbers
                const totalInUnit = web3.utils.fromWei(totalLockedAmount, 'ether');
                const availableInUnit = web3.utils.fromWei(availableAmount, 'ether');
                console.log('totalInUnit', totalInUnit);
                console.log('availableInUnit', availableInUnit);
                // Calculate allocated amount (total minus available)
                const allocatedInUnit = Number(totalInUnit) - Number(availableInUnit);
                console.log('allocatedInUnit', allocatedInUnit);
                // Update data
                this.totalAmount = this.formatNumber(totalInUnit);
                this.releasableAmount = this.formatNumber(availableInUnit);
                this.releasedAmount = this.formatNumber(allocatedInUnit > 0 ? allocatedInUnit : 0);

                // Calculate progress percentage
                if (Number(totalInUnit) > 0) {
                    this.progressPercent = (availableInUnit / Number(totalInUnit)) * 100;
                    // Ensure percentage is not negative and doesn't exceed 100
                    this.progressPercent = Math.max(0, Math.min(100, this.progressPercent));
                }
                console.log('this.progressPercent', this.progressPercent);

                this.statsLoading = false;
            } catch (err) {
                console.error('Failed to get contract data:', err);
                this.statsLoading = false;

                // Show error message
                this.$refs.ErrorMsg && this.$refs.ErrorMsg.showErrorMsg('Failed to get airdrop statistics');
            }
        },
        goBack() {
            this.$router.push('/airdropPlan')
        },

        onReleasePercentageChange() {
            console.log('onReleasePercentageChange', this.planForm.releasePercentage);
            // Calculate release amount based on percentage
            if (this.planForm.releasePercentage) {
                const totalAmountValue = parseFloat(this.totalAmount.replace(/,/g, ''));
                const releasableAmountValue = parseFloat(this.releasableAmount.replace(/,/g, ''));
                const percentage = parseFloat(this.planForm.releasePercentage);

                // 计算最大可用的百分比
                const maxPercentage = (releasableAmountValue / totalAmountValue) * 100;

                if (!isNaN(totalAmountValue) && !isNaN(percentage)) {
                    // 检查百分比是否超过最大可用百分比
                    if (percentage > maxPercentage) {
                        this.releasePercentageError = `Exceeds available limit, maximum percentage is ${maxPercentage.toFixed(2)}%`;
                        // 将百分比限制在最大值
                        this.planForm.releasePercentage = maxPercentage.toFixed(2);
                        this.planForm.planAmount = releasableAmountValue.toString();
                    } else {
                        this.releasePercentageError = '';
                        // 修复精度问题，计算release amount后使用合适的精度处理
                        const calculatedAmount = (totalAmountValue * percentage / 100);
                        // 格式化金额，去除尾随零
                        const formattedAmount = calculatedAmount.toFixed(12).replace(/\.?0+$/, '');
                        this.planForm.planAmount = formattedAmount;
                    }
                    this.validatePlanAmount();
                }
            } else {
                this.releasePercentageError = '';
            }
        },

        onPlanAmountChange() {
            // Calculate percentage based on release amount
            if (this.planForm.planAmount) {
                const totalAmountValue = parseFloat(this.totalAmount.replace(/,/g, ''));
                const releasableAmountValue = parseFloat(this.releasableAmount.replace(/,/g, ''));
                const planAmount = parseFloat(this.planForm.planAmount);

                if (!isNaN(totalAmountValue) && !isNaN(planAmount) && totalAmountValue > 0) {
                    // 检查计划发布金额是否超过可发布金额
                    if (planAmount > releasableAmountValue) {
                        this.planAmountError = `Exceeds available limit, maximum amount is ${this.releasableAmount} UNIT`;
                        // 将计划金额限制在最大值
                        this.planForm.planAmount = releasableAmountValue.toString();
                        this.planForm.releasePercentage = ((releasableAmountValue / totalAmountValue) * 100).toFixed(2);
                    } else {
                        this.planAmountError = '';
                        // 修复精度问题，计算percentage后使用合适的精度处理
                        const calculatedPercentage = (planAmount / totalAmountValue) * 100;
                        console.log('calculatedPercentage', calculatedPercentage);

                        // 处理科学计数法和精度问题
                        let formattedPercentage;
                        if (calculatedPercentage < 0.000001) {
                            // 对于非常小的百分比，使用更高精度
                            formattedPercentage = calculatedPercentage.toFixed(12).replace(/\.?0+$/, '');
                        } else if (calculatedPercentage < 0.01) {
                            // 对于小于0.01%的百分比，保留更多小数位
                            formattedPercentage = calculatedPercentage.toFixed(8).replace(/\.?0+$/, '');
                        } else {
                            // 对于正常范围的百分比，保留合理的小数位
                            formattedPercentage = calculatedPercentage.toFixed(6).replace(/\.?0+$/, '');
                        }

                        this.planForm.releasePercentage = formattedPercentage;
                    }
                    this.validateReleasePercentage();
                }
            } else {
                this.planAmountError = '';
            }

            // 重新计算白名单总额以更新验证状态
            this.calculateWhitelistTotal();
        },

        validatePlanAmount() {
            const releasableAmountValue = parseFloat(this.releasableAmount.replace(/,/g, ''));
            const planAmount = parseFloat(this.planForm.planAmount || 0);

            // 检查是否大于0
            if (planAmount <= 0) {
                this.planAmountError = 'Planned release amount must be greater than 0';
                return false;
            }

            if (planAmount > releasableAmountValue) {
                this.planAmountError = `Exceeds available limit, maximum amount is ${this.releasableAmount} UNIT`;
                return false;
            } else {
                this.planAmountError = '';
                return true;
            }
        },

        validateReleasePercentage() {
            const totalAmountValue = parseFloat(this.totalAmount.replace(/,/g, ''));
            const releasableAmountValue = parseFloat(this.releasableAmount.replace(/,/g, ''));
            const maxPercentage = (releasableAmountValue / totalAmountValue) * 100;
            const currentPercentage = parseFloat(this.planForm.releasePercentage || 0);

            // 检查是否大于0
            if (currentPercentage <= 0) {
                this.releasePercentageError = 'Release percentage must be greater than 0';
                return false;
            }

            if (currentPercentage > maxPercentage) {
                this.releasePercentageError = `Exceeds available limit, maximum percentage is ${maxPercentage.toFixed(2)}%`;
                return false;
            } else {
                this.releasePercentageError = '';
                return true;
            }
        },

        calculateWhitelistTotal() {
            let total = 0;
            for (const item of this.whitelist) {
                if (item.amount) {
                    try {
                        // 转换为数字并确保是有效的数值
                        const amount = parseFloat(item.amount.toString());
                        if (!isNaN(amount)) {
                            total += amount;
                        } else {
                            console.warn('无效的金额值:', item.amount);
                        }
                    } catch (e) {
                        console.error('计算总额出错:', e, item);
                    }
                }
            }

            // 使用toFixed修复浮点数精度问题
            this.whitelistTotal = parseFloat(total.toFixed(12));

            // Check if total matches planned release amount
            const planAmount = parseFloat(this.planForm.planAmount || 0);
            console.log('total', total);
            console.log('planAmount', planAmount);

            // 使用字符串比较来避免浮点数精度问题
            const totalStr = total.toFixed(12);
            const planAmountStr = planAmount.toFixed(12);

            if (totalStr !== planAmountStr) {
                this.whitelistError = "Total amount of tokens to be released does not match the total amount assigned in the whitelist.";
            } else {
                this.whitelistError = '';
            }
        },

        addWhitelistItem() {
            this.whitelist.push({ address: '', amount: '', selected: false });
        },

        deleteWhitelistItem(index) {
            this.whitelist.splice(index, 1);
            this.calculateWhitelistTotal();
        },

        importWhitelist() {
            this.importWhitelistVisible = true;
        },

        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return Promise.resolve();

            // 创建FormData对象
            const formData = new FormData();
            formData.append('csv', file);

            // 显示加载状态
            const loading = this.$loading({
                lock: true,
                text: 'Importing whitelist...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                // 调用API接口
                const response = await includeCsv(formData);
                console.log('CSV导入返回数据:', response);

                if (response.code === 0 && Array.isArray(response.data)) {
                    // 解析并设置白名单数据
                    let truncatedCount = 0; // 记录被截断的数量

                    let importedData = response.data.map(item => {
                        console.log('处理白名单项:', item);

                        // 检查并获取账户地址，考虑各种可能的键名
                        let accountValue = '';
                        // 遍历对象的所有键，找到包含"account"的键（不区分大小写）
                        for (const key in item) {
                            if (key.toLowerCase().includes('account')) {
                                accountValue = item[key];
                                console.log(`找到账户字段: ${key} = ${accountValue}`);
                                break;
                            }
                        }

                        // 确保账户地址格式正确
                        // 去除零宽不换行空格(ZERO WIDTH NO-BREAK SPACE)、双引号和其他不可见特殊字符
                        const address = (accountValue || '').replace(/[\uFEFF\u200B-\u200D\u2060\u00A0"]/g, '').trim();
                        console.log('清理后的地址:', address);

                        // 处理金额
                        let amount = '';
                        if (item.amount) {
                            try {
                                // 先清理金额中的空格和特殊字符
                                const cleanAmount = item.amount.toString().replace(/\s+/g, '');
                                console.log('清理前金额:', item.amount, '清理后:', cleanAmount);

                                // 先转换，然后检查是否需要截断
                                const originalResult = this.formatWeiToUnitOriginal(cleanAmount);
                                console.log('originalResult', originalResult);
                                amount = this.limitDecimalPlaces(originalResult, 12);
                                console.log('amount', amount);

                                // 检查是否发生了截断
                                if (originalResult !== amount) {
                                    truncatedCount++;
                                    console.log('金额被截断:', originalResult, '->', amount);
                                }
                            } catch (err) {
                                console.error('处理金额出错:', err, item);
                            }
                        }

                        return { address, amount, selected: false };
                    });

                    // 检查并处理重复地址
                    const duplicateResult = this.handleDuplicateAddresses(importedData);
                    importedData = duplicateResult.filteredAddresses;

                    // 检查导入的地址是否与现有地址重复
                    const duplicatesWithExisting = [];
                    if (this.whitelist.length > 0 && this.whitelist[0].address) {
                        const existingAddresses = this.whitelist.map(item => item.address.toLowerCase());

                        importedData = importedData.filter((item, index) => {
                            // 如果导入的地址与现有地址重复
                            if (item.address && existingAddresses.includes(item.address.toLowerCase())) {
                                duplicatesWithExisting.push(item.address);
                                return false;
                            }
                            return true;
                        });
                    }

                    // 将过滤后的数据添加到白名单
                    this.whitelist = [...this.whitelist, ...importedData];

                    this.calculateWhitelistTotal();

                    // 构建综合的导入结果消息
                    let importMessage = 'Whitelist imported successfully';
                    const warnings = [];

                    // 检查是否有导入数据内部重复地址被移除
                    if (duplicateResult.duplicateCount > 0) {
                        warnings.push(`${duplicateResult.duplicateCount} duplicate addresses in import data removed`);
                    }

                    // 检查是否有与现有地址重复的被移除
                    if (duplicatesWithExisting.length > 0) {
                        warnings.push(`${duplicatesWithExisting.length} addresses already exist and removed`);
                    }

                    // 检查是否有金额被截断
                    if (truncatedCount > 0) {
                        warnings.push(`${truncatedCount} amounts truncated to 12 decimal places`);
                    }

                    // 如果有警告信息，将其添加到消息中
                    if (warnings.length > 0) {
                        importMessage += `. ${warnings.join(', ')}.`;
                       this.$message.warning(importMessage);
                    } else {
                       this.$message.success(importMessage);
                    }
                } else {
                    this.$message.error('Failed to import whitelist: ' + (response.message || 'Unknown error'));
                }
            } catch (error) {
                console.error('导入白名单失败:', error);
                this.$message.error('Failed to import whitelist: ' + (error.message || 'Unknown error'));
            } finally {
                // 关闭加载状态
                loading.close();
                // 重置文件输入，以便再次选择同一文件
                event.target.value = '';
            }
        },

        // 限制数值的小数位数到12位
        limitDecimalPlaces(value, maxDecimals = 12) {
            if (!value || value === '') return '';

            const strValue = value.toString();
            if (!strValue.includes('.')) return strValue;

            const parts = strValue.split('.');
            if (parts[1] && parts[1].length > maxDecimals) {
                return parts[0] + '.' + parts[1].substring(0, maxDecimals);
            }

            return strValue;
        },

        // 不截断的原始wei转换方法，用于检查是否需要截断
        formatWeiToUnitOriginal(weiAmount) {
            try {
                // 确保weiAmount是字符串或数字
                if (weiAmount === null || weiAmount === undefined) {
                    console.warn('weiAmount为空值');
                    return '';
                }

                // 直接返回原始值，不移除小数点
                const result = weiAmount.toString();
                return result;
            } catch (error) {
                console.error('转换wei到UNIT失败:', error, '原始值:', weiAmount);
                return '';
            }
        },

        // 添加一个辅助方法将wei转换为UNIT (带12位小数限制)
        formatWeiToUnit(weiAmount) {
            const originalResult = this.formatWeiToUnitOriginal(weiAmount);
            return this.limitDecimalPlaces(originalResult, 12);
        },

        validateForm() {
            let isValid = true;

            // Validate plan name
            if (!this.planForm.planName) {
                this.planNameError = 'This name already exists. Please modify it.';
                isValid = false;
            } else {
                this.planNameError = '';
            }

            // Validate release amount
            if (!this.planForm.planAmount) {
                this.$message.error('Please enter planned release amount');
                isValid = false;
            } else if (parseFloat(this.planForm.planAmount) <= 0) {
                this.$message.error('Planned release amount must be greater than 0');
                isValid = false;
            } else if (!this.validatePlanAmount()) {
                isValid = false;
            }

            // Validate release percentage
            if (!this.planForm.releasePercentage) {
                this.$message.error('Please enter release percentage');
                isValid = false;
            } else if (parseFloat(this.planForm.releasePercentage) <= 0) {
                this.$message.error('Release percentage must be greater than 0');
                isValid = false;
            } else if (!this.validateReleasePercentage()) {
                isValid = false;
            }

            // Validate unlock date
            if (!this.planForm.unlockDate) {
                this.$message.error('Please select unlock date');
                isValid = false;
            } else {
                // 验证解锁日期必须大于当前时间
                const currentTime = Date.now();
                if (this.planForm.unlockDate <= currentTime) {
                    this.unlockDateError = 'Unlock date must be greater than current time';
                    isValid = false;
                } else {
                    this.unlockDateError = '';
                }
            }

            // 如果选择了线性解锁，验证相关字段
            if (this.planForm.unlockFrequency === 1) {
                if (!this.planForm.distributionFrequency) {
                    this.$message.error('Please enter distribution frequency');
                    isValid = false;
                } else if (this.planForm.distributionFrequency === '0' || parseInt(this.planForm.distributionFrequency) === 0) {
                    this.distributionFrequencyError = 'Distribution frequency cannot be 0';
                    isValid = false;
                } else if (parseInt(this.planForm.distributionFrequency) > parseInt(this.planForm.unlockPeriod)) {
                    this.distributionFrequencyError = 'Distribution frequency must be less than or equal to unlock period';
                    isValid = false;
                }

                if (!this.planForm.unlockPeriod) {
                    this.$message.error('Please enter unlock period');
                    isValid = false;
                }
            }

            // Validate whitelist
            if (!this.isWhitelistValid) {
                if (this.whitelist.length === 0) {
                    this.whitelistError = 'Please add at least one whitelist address';
                } else {
                    this.whitelistError = 'Total amount of tokens to be released does not match the total amount assigned in the whitelist.';
                }
                isValid = false;
            } else {
                this.whitelistError = '';
            }

            // 验证所有地址格式
            if (!this.validateAllAddresses()) {
                this.$message.error('Please check all addresses format');
                isValid = false;
            }

            return isValid;
        },

        showConfirmation() {
            if (!this.validateForm()) return;

            // 使用字符串比较来避免浮点数精度问题
            const whitelistTotalStr = this.whitelistTotal.toFixed(12);
            const planAmountStr = parseFloat(this.planForm.planAmount).toFixed(12);

            if (whitelistTotalStr !== planAmountStr) {
                this.$confirm('Release Amount Mismatch. The total amount of tokens to be released does not match the total amount assigned in the whitelist. Please verify your configuration before submitting.', 'Warning', {
                    confirmButtonText: 'OK',
                    type: 'warning',
                    showCancelButton: false
                });
                return;
            }

            // 显示地址确认弹窗
            this.confirmSuccess = false;
            this.addressConfirmVisible = true;
        },

        confirmAddresses() {
            // 如果已经在加载中，不执行操作
            if (this.confirmLoading) return;

            // 设置加载状态
            this.confirmLoading = true;

            // 清除之前的定时器
            if (this.confirmTimer) {
                clearTimeout(this.confirmTimer);
            }

            // 设置防抖定时器
            this.confirmTimer = setTimeout(() => {
                // 显示确认成功提示
                this.confirmSuccess = true;


                this.addressConfirmVisible = false;
                this.submitPlan();
                // 重置加载状态
                this.confirmLoading = false;

            }, 300); // 300ms 防抖延迟
        },

        async submitPlan() {
            try {
                this.submitting = true;

                // 初始化Web3
                let web3;
                if (window.ethereum) {
                    web3 = new Web3(window.ethereum);
                }

                // Build API parameters
                const params = {
                    planName: this.planForm.planName,
                    planAmount: web3.utils.toWei(this.planForm.planAmount, 'ether'), // 将UNIT转换为wei
                    claimMethod: this.planForm.claimMethod,
                    unlockFrequency: this.planForm.unlockFrequency,
                    unlockDate: parseInt(this.planForm.unlockDate / 1000), // Convert to seconds
                    accounts: this.whitelist.map(item => {
                        // 再次确保地址没有特殊字符和双引号
                        const cleanAddress = item.address.replace(/[\uFEFF\u200B-\u200D\u2060\u00A0"]/g, '').trim();
                        return {
                            address: cleanAddress,
                            amount: web3.utils.toWei(item.amount, 'ether') // 将每个账户的UNIT转换为wei
                        };
                    })
                };

                // 只有选择了线性解锁(1)时才添加distributionFrequency和unlockPeriod参数
                if (this.planForm.unlockFrequency === 1) {
                    params.distributionFrequency = this.planForm.distributionFrequency;
                    params.unlockPeriod = this.planForm.unlockPeriod;
                }

                // Send request to API
                const response = await setPlan(params);

                if (response && response.code === 0) {
                    this.$message.success('Airdrop plan added successfully');
                    this.goBack();
                } else {
                    // this.$message.error(response?.message || '添加空投计划失败');
                    // this.$message.error(response?.message || '添加空投计划失败');
                }
            } catch (error) {
                console.error('Failed to add airdrop plan:', error);
                // this.$message.error('Failed to add airdrop plan: ' + (error.message || 'Unknown error'));
            } finally {
                this.submitting = false;
                // 确保确认加载状态被重置
                this.confirmLoading = false;
            }
        },

        disablePastDates(time) {
            // 获取今天的开始时间（00:00:00）
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            // 禁用今天及之前的日期
            return time.getTime() < today.getTime() + 24 * 60 * 60 * 1000;
        },

        validateAddress(index) {
            // 清理地址中可能存在的零宽不换行空格、双引号和其他不可见字符
            const rawAddress = this.whitelist[index].address || '';
            const cleanedAddress = rawAddress.replace(/[\uFEFF\u200B-\u200D\u2060\u00A0"]/g, '').trim();

            // 如果清理后的地址与原地址不同，则更新地址
            if (cleanedAddress !== rawAddress) {
                this.$set(this.whitelist[index], 'address', cleanedAddress);
            }

            // 检查地址是否是有效的以太坊地址：0x开头的42位十六进制字符串
            const isValidAddress = /^0x[0-9a-fA-F]{40}$/.test(cleanedAddress);

            if (!cleanedAddress) {
                this.$set(this.whitelist[index], 'addressError', '');
            } else if (!isValidAddress) {
                this.$set(this.whitelist[index], 'addressError', 'Invalid address format, must be 42-character hexadecimal string starting with 0x');
            } else {
                // 检查地址是否重复
                const isDuplicate = this.checkDuplicateAddress(cleanedAddress, index);
                if (isDuplicate) {
                    this.$set(this.whitelist[index], 'addressError', 'Duplicate address, please enter a unique address');
                } else {
                    this.$set(this.whitelist[index], 'addressError', '');
                }
            }

            return (isValidAddress && !this.checkDuplicateAddress(cleanedAddress, index)) || !cleanedAddress;
        },

        // 检查地址是否重复，排除自身索引
        checkDuplicateAddress(address, currentIndex) {
            if (!address) return false;

            return this.whitelist.some((item, index) => {
                // 跳过与当前项相同的索引
                if (index === currentIndex) return false;

                // 忽略大小写进行比较
                return item.address.toLowerCase() === address.toLowerCase();
            });
        },

        validateAllAddresses() {
            let allValid = true;
            for (let i = 0; i < this.whitelist.length; i++) {
                if (!this.validateAddress(i) && this.whitelist[i].address) {
                    allValid = false;
                }
            }
            return allValid;
        },

        getFullyUnlockedDate(item) {
            if (!this.planForm.unlockDate || !this.planForm.unlockPeriod) {
                return 'N/A';
            }

            // 获取开始日期
            const startDate = new Date(this.planForm.unlockDate);

            // 计算完全解锁日期 = 开始日期 + 解锁周期
            const fullyUnlockedDate = new Date(startDate.getTime());
            fullyUnlockedDate.setDate(startDate.getDate() + parseInt(this.planForm.unlockPeriod));

            // 格式化日期为 YYYY-MM-DD hh:mm:ss
            return fullyUnlockedDate.toISOString().replace('T', ' ').slice(0, 16);
        },

        getUnlockTimes(item) {
            if (!this.planForm.unlockDate || !this.planForm.unlockPeriod || !this.planForm.distributionFrequency || parseInt(this.planForm.distributionFrequency) === 0) {
                return 'N/A';
            }
            // 解锁次数 = 解锁周期 / 分配频率
            const unlockTimes = Math.floor(parseInt(this.planForm.unlockPeriod) / parseInt(this.planForm.distributionFrequency)) + 1;

            return unlockTimes;
        },

        getAmountPerUnlock(item) {
            if (!item.amount || parseFloat(item.amount) === 0) {
                return 'N/A';
            }

            const unlockTimes = this.getUnlockTimes(item);
            if (unlockTimes === 'N/A' || unlockTimes === 0) {
                return 'N/A';
            }
            console.log('unlockTimes', unlockTimes);
            // 每次解锁金额 = 总金额 / 解锁次数
            const amountPerUnlock = parseFloat(item.amount) / unlockTimes;

            // 格式化为最多12位小数
            return amountPerUnlock.toFixed(Math.min(12, (amountPerUnlock.toString().split('.')[1] || '').length));
        },

        validateDistributionFrequency() {
            // 检查分配频率不能为0
            if (this.planForm.distributionFrequency === '0' || parseInt(this.planForm.distributionFrequency) === 0) {
                this.distributionFrequencyError = 'Distribution frequency cannot be 0';
                return;
            }

            if (parseInt(this.planForm.distributionFrequency) > parseInt(this.planForm.unlockPeriod)) {
                this.distributionFrequencyError = 'Distribution frequency must be less than or equal to unlock period';
            } else {
                this.distributionFrequencyError = '';
            }
        },

        validateUnlockPeriod() {
            // 当解锁周期改变时，重新验证分配频率
            if (this.planForm.distributionFrequency) {
                this.validateDistributionFrequency();
            }
        },

        // 处理日期变化，将选择的日期转换为UTC显示
        handleDateChange(date) {
            if (!date) {
                this.formattedUtcTime = '';
                return;
            }

            const dateObj = new Date(date);
            this.formattedUtcTime = dateObj.toISOString().replace('T', ' ').slice(0, 16);
        },

        handleSelectAllChange(value) {
            this.whitelist.forEach(item => {
                item.selected = value;
            });
        },

        batchDeleteWhitelistItems() {
            this.whitelist = this.whitelist.filter(item => !item.selected);
            this.calculateWhitelistTotal();
            // 删除后将全选状态设为false
            this.selectAll = false;
        },

        // 监听单个选项的变化来更新全选状态
        handleItemSelectChange() {
            this.selectAll = this.isAllSelected;
        },

        // 当导入白名单时检查并处理重复地址
        handleDuplicateAddresses(addresses) {
            const uniqueAddresses = [];
            const duplicateIndices = [];

            // 找出所有重复的地址索引
            addresses.forEach((item, index) => {
                const cleanAddress = item.address.toLowerCase();

                // 如果地址已存在于uniqueAddresses中，则将其索引添加到duplicateIndices
                if (uniqueAddresses.some(addr => addr.toLowerCase() === cleanAddress)) {
                    duplicateIndices.push(index);
                } else {
                    uniqueAddresses.push(item.address);
                }
            });

            // 返回结果对象，包含过滤后的地址和重复数量
            return {
                filteredAddresses: addresses.filter((_, index) => !duplicateIndices.includes(index)),
                duplicateCount: duplicateIndices.length
            };
        },

        // 均分Planned release数量
        distributeAmountEvenly() {
            // 检查是否设置了计划释放数量
            if (!this.planForm.planAmount || parseFloat(this.planForm.planAmount) <= 0) {
                this.$message.warning('Please set the Planned release amount first');
                return;
            }

            // 检查是否有白名单地址
            if (this.whitelist.length === 0) {
                this.$message.warning('Please add whitelist addresses first');
                return;
            }

            const validAddresses = this.whitelist.filter(item => item.address && !item.addressError);
            if (validAddresses.length === 0) {
                this.$message.warning('No valid whitelist addresses found');
                return;
            }

            // 计算每个地址应得的金额
            const totalAmount = parseFloat(this.planForm.planAmount);
            const count = validAddresses.length;

            // 检查是否能够精确均分 - 使用更可靠的方法
            // 将数值转为整数后判断是否能整除，避免浮点数精度问题
            const isExactlyDivisible = this.isExactlyDivisible(totalAmount, count);

            if (!isExactlyDivisible) {
                // 计算12位精度下的每个地址分配金额
                const amountPerAddress = parseFloat((totalAmount / count).toFixed(12)).toString().replace(/\.?0+$/, '');

                this.$confirm(`Cannot distribute amount evenly. Each address will receive ${amountPerAddress} UNIT, but the total will not match the planned release amount. Continue?`, 'Warning', {
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    // 用户确认继续
                    this.applyEvenDistribution(validAddresses, amountPerAddress);
                }).catch(() => {
                    // 用户取消
                    this.$message.info('Distribution canceled');
                });
            } else {
                // 可以精确均分
                const amountPerAddress = parseFloat((totalAmount / count).toFixed(12)).toString().replace(/\.?0+$/, '');
                this.applyEvenDistribution(validAddresses, amountPerAddress);
            }
        },

        // 检查数值是否能够被精确整除，返回布尔值
        isExactlyDivisible(totalAmount, count) {
            // 转换为字符串分析小数位数
            const totalStr = totalAmount.toString();
            const decimalPlaces = totalStr.includes('.') ? totalStr.split('.')[1].length : 0;

            // 将数值放大为整数，避免浮点数计算精度问题
            const multiplier = Math.pow(10, decimalPlaces);
            const totalAsInt = Math.round(totalAmount * multiplier);

            // 在整数域检查是否能整除
            return totalAsInt % count === 0;
        },

        // 应用均分结果
        applyEvenDistribution(validAddresses, amountPerAddress) {
            // 先处理有效地址
            for (const item of this.whitelist) {
                if (item.address && !item.addressError) {
                    item.amount = amountPerAddress;
                }
            }

            // 重新计算白名单总额
            this.calculateWhitelistTotal();
            this.$message.success('Amount distributed successfully');
        },

        handlePlanAmountInput(value) {
            // 只允许数字和小数点，限制多个小数点
            let cleanValue = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^(\d*\.\d*)\./g, '$1');

            // 实时更新值
            this.planForm.planAmount = cleanValue;
            this.onPlanAmountChange();
        },

        formatPlanAmount() {
            if (!this.planForm.planAmount) return;

            let value = this.planForm.planAmount;

            // 去除开头的0，但保留单个0（如果是0.xx的情况）
            if (value.startsWith('0') && value.length > 1 && value[1] !== '.') {
                value = value.replace(/^0+/, '');
            }

            // 如果清空了所有字符或者只剩下小数点，设为空
            if (value === '' || value === '.') {
                value = '';
            }

            // 如果是数字，格式化去除尾随零
            if (value && !isNaN(parseFloat(value))) {
                const num = parseFloat(value);
                // 保持最多12位小数精度，并去除尾随零
                value = num.toFixed(12).replace(/\.?0+$/, '');
            }

            this.planForm.planAmount = value;
            this.onPlanAmountChange();
            // 格式化后立即验证
            this.validatePlanAmount();
        },

        handleReleasePercentageInput(value) {
            // 只允许数字和小数点，限制多个小数点
            let cleanValue = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^(\d*\.\d*)\./g, '$1');

            // 实时更新值
            this.planForm.releasePercentage = cleanValue;
            this.onReleasePercentageChange();
        },

        formatReleasePercentage() {
            if (!this.planForm.releasePercentage) return;

            let value = this.planForm.releasePercentage;

            // 去除开头的0，但保留单个0（如果是0.xx的情况）
            if (value.startsWith('0') && value.length > 1 && value[1] !== '.') {
                value = value.replace(/^0+/, '');
            }

            // 如果清空了所有字符或者只剩下小数点，设为空
            if (value === '' || value === '.') {
                value = '';
            }

            // 如果是数字，格式化去除尾随零
            if (value && !isNaN(parseFloat(value))) {
                const num = parseFloat(value);
                // 保持最多12位小数精度，并去除尾随零
                value = num.toFixed(12).replace(/\.?0+$/, '');
            }

            this.planForm.releasePercentage = value;
            this.onReleasePercentageChange();
            // 格式化后立即验证
            this.validateReleasePercentage();
        },

        handleWhitelistAmountInput(value, index) {
            // 只允许数字和小数点，限制多个小数点
            let cleanValue = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^(\d*\.\d*)\./g, '$1');

            // 限制小数位数不超过12位
            if (cleanValue.includes('.')) {
                const parts = cleanValue.split('.');
                if (parts[1] && parts[1].length > 12) {
                    cleanValue = parts[0] + '.' + parts[1].substring(0, 12);
                }
            }

            // 实时更新值
            this.$set(this.whitelist[index], 'amount', cleanValue);
            this.calculateWhitelistTotal();
        },

        formatWhitelistAmount(index) {
            if (!this.whitelist[index].amount) return;

            let value = this.whitelist[index].amount;

            // 去除开头的0，但保留单个0（如果是0.xx的情况）
            if (value.startsWith('0') && value.length > 1 && value[1] !== '.') {
                value = value.replace(/^0+/, '');
            }

            // 如果清空了所有字符或者只剩下小数点，设为空
            if (value === '' || value === '.') {
                value = '';
            }

            // 如果是数字，格式化去除尾随零
            if (value && !isNaN(parseFloat(value))) {
                const num = parseFloat(value);
                // 保持最多12位小数精度，并去除尾随零
                value = num.toFixed(12).replace(/\.?0+$/, '');
            }

            this.$set(this.whitelist[index], 'amount', value);
            this.calculateWhitelistTotal();
        },

        handleDistributionFrequencyInput(value) {
            // 只允许数字，去除所有非数字字符
            let cleanValue = value.replace(/[^\d]/g, '');

            // 实时更新值
            this.planForm.distributionFrequency = cleanValue;
            this.validateDistributionFrequency();
        },

        formatDistributionFrequency() {
            if (!this.planForm.distributionFrequency) return;

            let value = this.planForm.distributionFrequency;

            // 去除开头的0，但如果全是0则保留一个0
            if (value.startsWith('0') && value.length > 1) {
                value = value.replace(/^0+/, '') || '0';
            }

            // 如果清空了所有字符，设为空
            if (value === '') {
                value = '';
            }

            this.planForm.distributionFrequency = value;
            this.validateDistributionFrequency();
        },

        handleUnlockPeriodInput(value) {
            // 只允许数字，去除所有非数字字符
            let cleanValue = value.replace(/[^\d]/g, '');

            // 实时更新值
            this.planForm.unlockPeriod = cleanValue;
            this.validateUnlockPeriod();
        },

        formatUnlockPeriod() {
            if (!this.planForm.unlockPeriod) return;

            let value = this.planForm.unlockPeriod;

            // 去除开头的0，但如果全是0则保留一个0
            if (value.startsWith('0') && value.length > 1) {
                value = value.replace(/^0+/, '') || '0';
            }

            // 如果清空了所有字符，设为空
            if (value === '') {
                value = '';
            }

            this.planForm.unlockPeriod = value;
            this.validateUnlockPeriod();
        },

        getStartDate() {
            if (!this.planForm.unlockDate) {
                return 'N/A';
            }

            const startDate = new Date(this.planForm.unlockDate);
            return startDate.toISOString().replace('T', ' ').slice(0, 16);
        },

        triggerFileInput() {
            this.$refs.importFileInput.click();
        },

        handleImportFileSelect(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.selectedFileName = file.name;
            // 不立即处理文件，等待用户点击Import按钮
        },

        clearSelectedFile() {
            this.selectedFileName = '';
            this.$refs.importFileInput.value = '';
        },

        // 清理无效的白名单项（address和amount同时为空）
        cleanupInvalidWhitelistItems() {
            const originalLength = this.whitelist.length;
            
            // 过滤掉address和amount同时为空的项
            this.whitelist = this.whitelist.filter(item => {
                const hasAddress = item.address && item.address.trim() !== '';
                const hasAmount = item.amount && item.amount.trim() !== '';
                
                // 保留至少有address或amount其中一个不为空的项
                return hasAddress || hasAmount;
            });

            const removedCount = originalLength - this.whitelist.length;
            
            // 如果清理了无效数据，显示提示信息
            if (removedCount > 0) {
                this.$message.info(`Removed ${removedCount} invalid entries (empty address and amount)`);
                // 重新计算白名单总额
                this.calculateWhitelistTotal();
            }

            // 如果清理后白名单为空，添加一个空项
            if (this.whitelist.length === 0) {
                this.whitelist.push({ address: '', amount: '', selected: false });
            }
        },

        handleImportConfirm() {
            const file = this.$refs.importFileInput.files[0];
            if (!file) {
                this.$message.warning('Please select a file first');
                return;
            }

            // 关闭弹窗
            this.importWhitelistVisible = false;

            // 处理文件上传
            this.handleFileUpload({ target: { files: [file] } }).then(() => {
                // 导入完成后，清理无效数据
                this.cleanupInvalidWhitelistItems();
            });

            // 清理选择的文件
            this.clearSelectedFile();
        },
    }
}
</script>

<style scoped>
.op-btn {
    margin-bottom: 0.24rem;
}

.op-btn .el-button {
    padding: 0.12rem 0.16rem;
    font-size: 0.18rem;
    line-height: 0.2rem;
    color: #626871;
    border-color: #d9dde3;
    background: #fff;
}

.release-percentage-label {
    min-width: auto;
    margin-left: 20px;
    margin-right: 15px;
}

.input-with-select {
    display: flex;
    align-items: center;
}

.input-with-select .el-input {
    margin-right: 10px;
}

.airdrop-status {
    margin-bottom: 20px;
    padding: 15px;

    border-radius: 4px;
}

.progress-container {
    margin: 10px 0;
    height: 20px;
    background-color: #e9ecef;
    border-radius: 10px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    /* background-color: #4cd79c; */
    background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
    border-radius: 10px;
}

.airdrop-numbers {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.form-container {
    margin-top: 20px;
}

.form-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.form-label {
    min-width: 150px;
    text-align: right;
    margin-right: 15px;
    font-weight: 500;
}

.unit-label {
    margin-left: 10px;
}

.error-message {
    color: #f56c6c;
    margin-left: 10px;
}

.percentage-tips {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
    text-align: right;
    align-items: flex-end;
    width: 80%;
    margin-top: 10px;
}

.radio-group {
    display: flex;
    gap: 20px;
}

.whitelist-section {
    margin-top: 30px;
}

.whitelist-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.whitelist-error {
    color: #f56c6c;
    margin-left: 10px;
}

.whitelist-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 15px;
}

.whitelist-table-header {
    display: flex;
    background-color: #f5f7fa;
    padding: 10px;
    border-bottom: 1px solid #ebeef5;
}

.whitelist-table-body {
    max-height: 300px;
    overflow-y: auto;
}

.whitelist-item {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid #ebeef5;
}

.whitelist-item:last-child {
    border-bottom: none;
}

.index-column {
    flex: 0.6;
    padding-right: 6px;
    display: flex;
    align-items: center;
}

.address-column {
    flex: 2;
    padding-right: 10px;
}

.amount-column {
    flex: 1;
    padding-right: 10px;
}

.extra-info-column {
    flex: 1;
    padding-right: 10px;
}

.info-text {
    color: #909399;
    font-size: 12px;
}

.action-column {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.info-icon {
    color: #e6a23c;
    cursor: pointer;
}

.whitelist-actions {
    display: flex;
    gap: 15px;
    margin-bottom: 30px;
}

.form-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
}

.address-confirmation {
    text-align: center;
    padding: 20px 0;
}

.confirm-text {
    margin-bottom: 30px;
    color: #333;
    font-size: 16px;
    text-align: left;
}

.confirm-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
}

.confirm-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f9eb;
    color: #67c23a;
    padding: 10px;
    border-radius: 4px;
    margin-top: 20px;
}

.confirm-tip i {
    margin-right: 5px;
    font-size: 18px;
}

.utc-time-note {
    margin-left: 10px;
    font-size: 14px;
    color: #409EFF;
    font-weight: 500;
}

.index-title {
    margin-left: 10px;
}

.index-number {
    margin-left: 10px;
    display: inline-block;
    min-width: 20px;
    text-align: center;
}

.import-whitelist-dialog {
    padding: 20px;
}

.import-description {
    margin-bottom: 30px;
    color: #606266;
    font-size: 14px;
    line-height: 1.5;
}

.file-upload-section {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
}

.choose-file-btn {
    padding: 12px 24px;
    background-color: #409EFF;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

.choose-file-btn:hover {
    background-color: #66b1ff;
}

.selected-file-name {
    margin-left: 15px;
    padding: 8px 12px;
    background-color: #f0f2f5;
    border-radius: 4px;
    color: #409EFF;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.selected-file-name .el-icon-close {
    margin-left: 8px;
    cursor: pointer;
    color: #909399;
}

.selected-file-name .el-icon-close:hover {
    color: #f56c6c;
}

.format-instructions {
    margin-bottom: 30px;
    background-color: #f8f9fb;
    padding: 20px;
    border-radius: 4px;
    border-left: 4px solid #409EFF;
}

.instructions-text {
    margin-bottom: 20px;
    color: #606266;
    font-size: 14px;
    line-height: 1.5;
}

.csv-format-title {
    margin-bottom: 10px;
    color: #303133;
    font-size: 14px;
    font-weight: 600;
}

.csv-format-example {
    margin-bottom: 20px;
    color: #409EFF;
    font-size: 14px;
    font-weight: 500;
    background-color: #ecf5ff;
    padding: 8px 12px;
    border-radius: 4px;
    display: inline-block;
}

.date-format-note {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
}

.date-format-note p {
    margin: 5px 0;
}

.dialog-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
}
</style>